export const ACTION_PREFIX = 'GLOBAL_LOADING_INDICATOR';
export const PARTITION = 'globalLoadingIndicator';

export const actionTypes = {
  ADD_COUNT: 'ADD_COUNT',
  SUBTRACT_COUNT: 'SUBTRACT_COUNT',
};
